<template>
	<dl class="grid grid-cols-[1fr_2fr]">
		<slot />
	</dl>
</template>
